import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';

import TextControl from '../components/customizedInputs/TextControl';

const Ingreso = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation, showSideMenu, setShowSideMenu] = useContext(InputContext)
  const [datosUsuario, setDatosUsuario] = useState({usuario: "", password: ""});

  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    }
  }, [authInformation]);

  const signIn = async () => {
    try {
      const data = await authServices.signIn(datosUsuario);

      if(data.token){
        localStorage.setItem('token', data.token);

        // const mensajes = await resourcesServices.obtenerResources('notificaciones');
        // setNotificaciones(mensajes.data);

        setAuthInformation({
          token: data.token,
          nombre: data.nombre,
          user_id: data.user_id,
          rol: data.rol,
          usuario: data.usuario,
          autenticado: true,
          es_supervisor: data.es_supervisor,
        })

      } else {
        setAuthInformation({token: undefined, user_id: undefined, rol: undefined, autenticado: false})
        localStorage.removeItem('token');
      }
    } catch (error) {
      errorMessage(error)
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setDatosUsuario({...datosUsuario,
        [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    if (!datosUsuario.usuario || !datosUsuario.password) {
      alert('Por favor, ingrese su usuario y contraseña.');
      return;
    }
    signIn()
  }


  return (
    <div>
      {(authInformation.autenticado === false) && (
        <main className="w-100 m-auto" style={{maxWidth: '330px'}}>
          <form>
            <h1>Ingreso</h1>
            {/* <pre>{JSON.stringify(authInformation, null, 2)}</pre> */}
            <TextControl
              value={datosUsuario.usuario}
              name={'usuario'}
              handleInput={handleInput}
              label='Usuario'
              />

            <TextControl
              value={datosUsuario.password}
              name={'password'}
              handleInput={handleInput}
              type='password'
              label='Clave'
              />

            <Link className="btn btn-link mb-3" to="/recuperoClave">Olvidaste la clave ?</Link>

            <button className="btn btn-primary mt-3" onClick={handleFormSubmit} type="submit">Entrar</button>
          </form>
        </main>
      )}

    </div>
  );
};

export default Ingreso;